import {Suspense, useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Outlet, useNavigate} from 'react-router-dom'
import {ToastContainer, toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {setMessage, removeMessage} from '../store/alertMessage/actions'
import {AuthInit} from './modules/auth'
import {configuration} from '../configuration.js'
import {setCityList, setDropdowmBranchList} from '../store/commonlist/actions'
import axios from 'axios'
import {removeShortCut, setShortCut} from 'src/store/shortCut/actions'
import AddMessage from './pages/AddMessage'
// import 'bootstrap/dist/css/bootstrap.min.css';
 
const App = () => {
  const API_URL = configuration.apiUrl
  const CITY_URL = `${API_URL}/cities`
  // const USER_URL = `${API_URL}/users`
  const DROPDOWN_BRANCHES_URL = `${API_URL}/branches/getDropDownBranches`
  const alertMessage = useSelector((state: any) => state.alertMessage.message)
  const alertStatus = useSelector((state: any) => state.alertMessage.status)
  const alertTime = useSelector((state: any) => state.alertMessage.time)
  const isLoggedIn = useSelector((state: any) => state.authDetail.isLoggedIn)
  const [isAddMessageModalOpen, setIsAddMessageModalOpen] = useState(false)
  const dispatch = useDispatch()

  const navigate = useNavigate()

  // const fetchUserPermissions = async (userId:any) => {
  //   try {
  //     const { data } = await axios.get(`${USER_URL}/${userId}?sort=name&order=ASC`)
  //     dispatch(setCityList(data?.responseData))
  //   } catch (error:any) {
  //     dispatch(setMessage('error', error.message))
  //   }
  // }

  // const getPermission = async () => {
  //   const userData = localStorage.getItem('branch')
  //   if (!userData) return
  //   const userId = JSON.parse(userData).id
  //   await fetchUserPermissions(userId)
  // }

  useEffect(() => {
    if (localStorage.getItem('authtoken')) {
      // getPermission()
    }
  }, [localStorage.getItem('authtoken')])

  const cityList = useSelector((state: any) => state.commonList.cityList)

  const isAdmin = cityList?.roleInfo?.id === 1 || cityList?.roleInfo?.id === 2
  const isMessageCreatePermission =
    cityList?.roleInfo?.id === 3 && cityList?.userPermissionInfo[0]?.message_is_create === true
  const isPartyCreatePermission =
    cityList?.roleInfo?.id === 3 && cityList?.userPermissionInfo[0]?.party_is_create === true

  const handleKeyboardShortcuts = (event: KeyboardEvent) => {
    // const key = event.key.toLowerCase()
const key = event?.key?.toLowerCase?.() || ''
    switch (key) {
      case 'd':
        if (  event.altKey || event.shiftKey ) {
          navigate('/dashboard')
          event.preventDefault()
        }
        break

      case 'p':
        if (  event.altKey || event.shiftKey ) {
          navigate('/report/party-ledger')
          event.preventDefault()
        }
        break

      case 't':
        if (event.shiftKey || event.altKey) {
          navigate('/report/transactions')
        }
        break

      case 'g':
        if (event.shiftKey || event.altKey) {
          navigate('/report/general-ledger')
        }
        break

      case 'h':
        if (event.shiftKey) {
     
          navigate('/party-entry/auto-vatav')
        }
        break

        case 'v':
        if (event.altKey) {
     
          navigate('/party-entry/auto-vatav')
        }
        break
        case 'm':
          if (event.altKey) {
       
            navigate('/partys/list-party')
          }
          break
      case 'n':
      
        if (event.altKey) {
          navigate('/party-entry/normal-entry')
        }
        break

      case 'c':
        if (event.shiftKey || event.altKey) {
      
          navigate('/report/city-wise')
        }
        break

      default:
        break
    }
  }

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      handleKeyboardShortcuts(event)
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  const fetchBranches = async () => {
    try {
      const {data} = await axios.get(`${DROPDOWN_BRANCHES_URL}?sort=branch_name&order=asc`)
      dispatch(
        setDropdowmBranchList(
          data?.responseData?.map((x: any) => ({
            label: x.branch_name,
            value: x.uuid,
            ...x,
          }))
        )
      )
    } catch (error: any) {
      dispatch(setMessage('error', error.message))
    }
  }

  const fetchCities = async () => {
    try {
      const {data} = await axios.get(`${CITY_URL}?sort=name&order=ASC`)
      dispatch(setCityList(data?.responseData))
    } catch (error: any) {
      dispatch(setMessage('error', error.message))
    }
  }

  useEffect(() => {
    if (alertMessage) {
      const message = alertMessage
      const status = alertStatus
      const time = alertTime
      dispatch(removeMessage())
      const toastOptions: any = {
        toastId: message,
        position: 'top-center',
        autoClose: time * 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      }
      if (status === 'success') {
        toast.success(message, toastOptions)
      } else if (status === 'error') {
        toast.error(message, toastOptions)
      }
    }
  }, [alertMessage])

  const closeModal = () => {
    setIsAddMessageModalOpen(false)
  }

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <ToastContainer limit={1} />
          <AuthInit>
            <Outlet />
            <MasterInit />
            {localStorage.getItem('authtoken') && (
              <AddMessage isOpen={isAddMessageModalOpen} onClose={closeModal} />
            )}
          </AuthInit>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
